<template>
    <div>
        <b-field label="Etiquetar productos a la publicacion:">
            <b-taginput
            v-model="tags"
            autocomplete
            rounded
            field="title"
            :data="productOptions"
            @typing="searchProducts"
            @add="creaTag"
            @remove="remTag"
            ref="taginput"
            icon="label"
            >
                <template slot-scope="props">
                <strong>{{props.option.code}}</strong> - {{props.option.title}}
                </template>
                <template slot="empty">
                    No encontramos ningun producto...
                </template>
            </b-taginput>
        </b-field>
        <div class="columns is-multiline">
            <div v-for="tag in tags" :key="tag.id" class="column is-half-mobile is-one-fifth-tablet is-one-quarter-desktop">
                <div class="card">
                    <div class="card-image has-text-centered">
                        <img :src="tag.productObj.getImage" alt="imagen-producto">
                    </div>
                    <div class="card-content">
                        <div class="content product-content">
                            <p class="has-text-weight-semibold">{{tag.productObj.title}}</p>
                            <div class="price has-text-centered">
                                <p style=" text-decoration: line-through; color:#333;" v-if="tag.productObj.status=='O'">
                                    {{tag.productObj.currencySymbol}} {{tag.compareAt}}
                                </p>
                                <p class="has-text-custom">{{tag.productObj.currencySymbol}} {{tag.productObj.price}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getHandler, postHandler, deleteHandler } from '../../../../services/http'
export default {
    props:{
        productSearch:{
            type:String,
            default:""
        },
        taggedProdListUrl:{
            type:String,
            default:""
        },
        entry:{
            type:Object,
            default: new Object({})
        },
        tagCreate:{
            type:String,
            default:""
        },
        tagRemove:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            tags:[],
            productOptions:[]
        }
    },
    methods:{
        async fetchTags(){
            this.tags = await getHandler(this.taggedProdListUrl, {error:false, success:false})
        },
        async searchProducts(text){
            var url = this.productSearch + `?search=${text}`
            var resp = await getHandler(url, {error:false, success:false})
            console.log(resp)
            this.productOptions = resp.results
        },
        async creaTag(prod){
            var msg = {
                resource:'notify'
            }
            var success = msg
            var error = msg
            var resp = await postHandler(this.tagCreate, {entry:this.entry.id, product:prod.id}, {error, success})
            this.fetchTags()
        },
        async remTag(prod){
            var msg = {
                resource:'notify'
            }
            var success = msg
            var error = msg
            var url = this.tagRemove.replace('0000', prod.id)
            var resp = await deleteHandler(url, {error, success})
            this.fetchTags()
        }

    },
    created(){
        this.fetchTags()
    }
}
</script>